import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  Environment,
  ICheckProfiloUtenteModel,
  IFastCreateUserFormModel,
  IsError,
  ModelStrStr,
  IProfiloUtenteModel,
  Utenti,
  IUtentiTableModel,
  IsErrorValues,
} from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';
import { Observable } from 'rxjs';

@Injectable()
export class UtentiService extends CrudGenericsService<Utenti, string> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Utenti`);
    this.base = `${env.apiUrl}/api/Utenti/`;
  }

  // table model
  GetAll_UtentiTableModel(): Observable<IUtentiTableModel[]> {
    const u = this.base + 'GetAll_UtentiTableModel';
    return this.http.get<IUtentiTableModel[]>(`${u}`);
  }
  // table edit
  GetSingle_IncludeCollections(id: string): Observable<Utenti> {
    const u = this.base + 'GetSingle_IncludeCollections?id=' + id;
    return this.http.get<Utenti>(`${u}`);
  }
  // table edit versione 2 params
  GetSingle_IncludeCollections_ByUserByAzb(id: string, azb: number = 0): Observable<Utenti> {
    if (azb == null) {
      azb = 0;
    }
    const u = `${this.base}GetSingle_IncludeCollections_ByUserByAzb?id=${id}&azb=${azb}`;
    return this.http.get<Utenti>(u);
  }
  Get4Select_byDiv(div: number): Observable<ModelStrStr[]> {
    const u = this.base + 'Get4Select_byDiv?div=' + div;
    return this.http.get<ModelStrStr[]>(`${u}`);
  }
  Get4Select_UtentiInDivRU_ByDiv(div: number): Observable<ModelStrStr[]> {
    const u = this.base + 'Get4Select_UtentiInDivRU_ByDiv?div=' + div;
    return this.http.get<ModelStrStr[]>(`${u}`);
  }
  //
  Update_CompexObject(item: Utenti) {
    const url = this.base + 'Update_CompexObject';
    return this.http.post(`${url}`, item);
  }
  // notifiche
  GetUtenti_AllNotifiche_ByTipNotByDiv(tip: number, div: number): Observable<Utenti[]> {
    const url = this.base + 'GetUtenti_AllNotifiche_ByTipNotByDiv?tip=' + tip + '&div=' + div;
    return this.http.get<Utenti[]>(`${url}`);
  }

  GetSingleUtente_AllNotifiche_ByDiv(ute: string, div: number): Observable<Utenti> {
    const url = this.base + 'GetSingleUtente_AllNotifiche_ByDiv?ute=' + ute + '&div=' + div;
    return this.http.get<Utenti>(`${url}`);
  }
  //
  CheckProfiloUtente(model: ICheckProfiloUtenteModel) {
    const url = this.base + 'CheckProfiloUtente';
    return this.http.post(`${url}`, model);
  }
  /* sostituito da sotto
  VerificaCampo(value: string, idutente: string, campo: string): Observable<ModelStrStr[]> {
    const u = this.base + 'VerificaCampo?value=' + value + '&id=' + idutente + '&campo=' + campo;
    return this.http.get<ModelStrStr[]>(`${u}`);
  }*/

  // profilo in menu web
  GetProfiloUtente(): Observable<IProfiloUtenteModel> {
    const u = this.base + 'GetProfiloUtente';
    return this.http.get<IProfiloUtenteModel>(`${u}`);
  }
  // web in Persone utenti form
  FastCreateUserFormModel(model: IFastCreateUserFormModel): Observable<IsErrorValues> {
    const url = this.base + 'FastCreateUserFormModel';
    return this.http.post<IsErrorValues>(url, model);
  }
  FastAddExistingUserToAzb(model: IFastCreateUserFormModel): Observable<IsErrorValues> {
    const url = this.base + 'FastAddExistingUserToAzb';
    return this.http.post<IsErrorValues>(`${url}`, model);
  }

  //
  SetDefaultAzb_OnChangeAzb(item: Utenti, new_azb: number) {
    const u = `${this.base}SetDefaultAzb_OnChangeAzb?new_azb=${new_azb}`;
    return this.http.post(u, item);
  }
}
